<template>
  <header v-show="page.show_intro" class="mb-6" :class="align">
    <div
      :class="{
        'flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center':
          $slots['header-content'],
      }"
    >
      <h1 class="text-3xl md:text-4xl">{{ render(page.title) }}</h1>

      <slot name="header-content" />
    </div>

    <div
      v-if="page.intro_text"
      class="mb-6 mt-2 article"
      v-html="render(page.intro_text)"
    ></div>
  </header>
</template>

<script>
import RenderVariables from '@/mixins/prismic/helpers/render-variables'
import { mapState } from 'vuex'

export default {
  mixins: [RenderVariables],

  props: {
    page: { type: Object, default: () => ({}) },

    /**
     * Context to render variables from. Pass "this._self" to
     * render variables from the parent component.
     */
    ctx: { type: Object, default: () => null },

    align: { type: String, default: 'text-center' },
  },

  computed: mapState(['enterprise']),
}
</script>
